const Verdict = (props) => {
  const decision = props?.row?.original?.decision;

  if (decision === 100) {
    return <div className="n-a">N/A</div>;
  } else if (decision === 2) {
    return <div className="malicious">Malicious</div>;
  } else if (decision === 1) {
    return <div className="suspicious">Suspicious</div>;
  } else if (decision === 0) {
    return <div className="clean">Not Suspicious</div>;
  }
};

export default Verdict;
